import styled from 'styled-components';
import { Colors } from '../../themes';

export const Container = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 13px 40px 13px 20px;

  background: transparent
    radial-gradient(closest-side at 50% 50%, #311452 0%, #1a082e 100%) 0% 0%
    no-repeat padding-box;
  box-shadow: 3px 6px 21px #00000064;
  border: 2px solid #ee1f99;
  border-radius: 10px;
  opacity: 0.69;
`;

export const Icon = styled.img`
  width: 28px;
  height: 28px;
  margin-right: 15px;
`;

export const Text = styled.span`
  font-size: 16px;
  letter-spacing: 0px;
  color: ${Colors.text.main};
`;
